import { APP_BASE_HREF } from '@angular/common';
import { LOCALE_ID, ModuleWithProviders, NgModule, Optional, SkipSelf, inject, provideAppInitializer } from '@angular/core';
import { ServerConfig, SERVER_CONFIG } from '../config';
import { AppLoadService } from './appload.service';

@NgModule()
export class AppLoadModule {
  constructor(@Optional() @SkipSelf() parentModule: AppLoadModule) {
    if (parentModule) {
      throw new Error($localize `AppLoadModule is already loaded. It should only be imported in your application's main module.`);
    }
  }
  static forRoot(): ModuleWithProviders<AppLoadModule> {
    return {
      ngModule: AppLoadModule,
      providers: [
        AppLoadService,
        provideAppInitializer(() => {
        const initializerFn = ((appLoadService: AppLoadService) => {
            return () => appLoadService.superInitializeApp();
          })(inject(AppLoadService));
        return initializerFn();
      }),
        {
          provide: APP_BASE_HREF,
          useFactory: (
            config: ServerConfig,
            locale: string
          ) => {
            console.log("SETUP: Locale", locale);
            let basePath;
            if (config.languages === undefined) {
               basePath = '/';
            } else {
              basePath = config.languages[locale] || document.getElementsByTagName('base')[0].getAttribute('href');
            }
            console.log('SETUP: Base path is', basePath);
            return basePath;
          },
          deps: [SERVER_CONFIG, LOCALE_ID],
        },
      ]
    };
  }
}
